// textArea.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './testiReview.css';

/**
 * Reusable textarea component for collecting user reviews/comments
 * @param {Object} props - Component props
 * @param {string|number} props.id - Unique identifier for the textarea
 * @param {string} [props.placeholder="Enter your comment"] - Placeholder text
 * @param {number} [props.rows=3] - Number of visible rows
 * @param {function} [props.onChange] - Optional callback for parent component
 */
const TextArea = ({
  id,
  placeholder = 'Enter your comment',
  rows = 3,
  onChange: externalOnChange,
}) => {
  const [text, setText] = useState('');
  const textReviewId = `textreview_${id}`;
  const labelId = `textarea-label-${id}`;

  /**
   * Handles changes to the textarea value
   * @param {Object} event - Change event object
   */
  const handleChange = event => {
    const newValue = event.target.value;
    setText(newValue);

    // Call external onChange handler if provided
    if (typeof externalOnChange === 'function') {
      externalOnChange(newValue);
    }
  };

  return (
    <div className="textarea-container">
      <textarea
        id={textReviewId}
        name={textReviewId}
        className="textarea-review"
        placeholder={placeholder}
        onChange={handleChange}
        value={text}
        rows={rows}
        aria-labelledby={labelId}
        aria-required="false"
      />
      <div className="textarea-counter" aria-live="polite">
        {text.length > 0 && <span className="character-count">{text.length} characters</span>}
      </div>
    </div>
  );
};

TextArea.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  onChange: PropTypes.func,
};

export default TextArea;
